import { render, staticRenderFns } from "./ImageFileInput.vue?vue&type=template&id=0fbdc2f8&scoped=true&"
import script from "./ImageFileInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImageFileInput.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ImageFileInput.vue?vue&type=style&index=0&id=0fbdc2f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbdc2f8",
  null
  
)

export default component.exports